import { ref, computed, reactive } from "vue"
import { userExist, usersState } from "./usersState"
import { authState } from "./auth"
import { getSharedUserIdIncludingThis } from "./screenShareState"

export const speakerSharePosition = reactive({
  x: 8,
  y: 8
})

let lastSpeakerTimeSet = -Infinity
const innerSpeaker = ref<string | null>(null)

export const speakerInSharedState = computed(() => {
  const sp = innerSpeaker.value ? (userExist(innerSpeaker.value) || innerSpeaker.value === authState.id ? innerSpeaker.value : null) : null
  const screenShare = getSharedUserIdIncludingThis()
  const firstUser = usersState.users[0]?.id
  return  sp || screenShare || firstUser
})

export function speakersUpdate(speakers: string[]) {
  if(speakers.length === 0) return
  if(!innerSpeaker.value) {
    innerSpeaker.value = speakers[0]
    lastSpeakerTimeSet = Date.now()
    return
  }
  const candidate = speakers[0]
  if(candidate !== innerSpeaker.value && Date.now() - lastSpeakerTimeSet > 3000) {
    innerSpeaker.value = candidate
    lastSpeakerTimeSet = Date.now()
  }
}
